<template>
    <div class="exam-course">
        <!-- 卡片展示 -->
        <el-card :body-style="{ padding: '0px' }">
            <div class="imgbox" @click="introductionVisible = true">
                <img :src="course.pictureUrl">
            </div>
            <div style="padding: 14px;">
                <span>{{course.name}}</span>
                <el-row>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
<!--                      登陆 && 不在考试中 && 没有批卷中-->
                        <time class="time"  v-if="isLogin &&!course.onTheExam && !course.reviewing">{{ `剩余次数${course.chance}` }}</time>
                        <div v-if="isLogin &&!course.onTheExam && !course.reviewing && course.chance>0">
                            <i class="el-icon-time time"></i>
                            <time class="time"  >{{ `${course.expireTime}` }}</time>
                        </div>
                        <time class="time"  v-else>&nbsp;</time>
                    </el-col>
                    <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                        <el-button type="text" v-if="course.onTheExam" @click="continueTest" class="to-test">
                            <span>继续考试</span>
                        </el-button>
                        <el-button type="text" v-if="!course.onTheExam && course.reviewing" disabled class="to-test">
                          <span>批卷中</span>
                        </el-button>
                        <el-button type="text" v-if="!course.onTheExam && !course.reviewing && course.chance>0 " @click="haveTest" class="to-test">
                            <span>开始考试</span>
                        </el-button>
                        <el-button type="text" v-if="!course.onTheExam && !course.reviewing && course.chance>0 && course.appointmentType==='appointment' && !course.alreadyAppointment" @click="checkBeforeAppointment" class="to-test">
                          <span>立即预约&nbsp;&nbsp;</span>
                        </el-button>
                        <el-button type="text" v-if="!course.onTheExam && !course.reviewing && course.chance>0 && course.appointmentType==='appointment' && course.alreadyAppointment" @click="searchAppointPlan" class="to-test">
                            <span>预约情况&nbsp;&nbsp;</span>
                        </el-button>
                        <el-button type="text" v-if="!course.onTheExam && !course.reviewing && (course.chance==0||!isLogin)" @click="toPay" class="to-test">
                            <span>立即购买</span>
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </el-card>

      <!-- 预约计划 -->
      <el-dialog :title="'预约科目:'+course.name" :visible.sync="appointmentVisible" center width="90%">
          <el-table :data="appointmentPlanList" >
              <el-table-column prop="planDate" label="日期" width="120px" align="center"></el-table-column>
              <el-table-column prop="openTime" label="开放时间" :formatter="timeFormat" width="120px"></el-table-column>
              <el-table-column prop="endTime" label="截止时间" :formatter="timeFormat" width="120px"></el-table-column>
              <el-table-column prop="closeTime" label="关闭时间" :formatter="timeFormat" width="120px"></el-table-column>
<!--              <el-table-column prop="startTime" label="开始时间" :formatter="timeFormat" width="90px"></el-table-column>-->

              <el-table-column label="状态">
                  <template slot-scope="scope">
                      <el-tag type="success" v-if="scope.row.alreadyExists">已报名</el-tag>
                      <el-tag  v-if="scope.row.cancelCount >0">已取消</el-tag>
                      <el-tag  v-if="!scope.row.alreadyExists && scope.row.quota > scope.row.userCount && scope.row.cancelCount ===0">可预约</el-tag>
                      <el-tag  type="info" v-if="!scope.row.alreadyExists && scope.row.quota <= scope.row.userCount">满员</el-tag>
                  </template>
              </el-table-column>
              <el-table-column label="操作" width="100px">
                  <template slot-scope="scope">
                      <el-button v-if="!scope.row.alreadyExists && !course.alreadyAppointment && scope.row.cancelCount === 0" size="small" @click="makeAppointment(scope.row.id)">预约</el-button>
                      <el-button v-if="scope.row.alreadyExists" :disabled="scope.row.cancelCount > 0"  size="small"  @click="cancelAppointment(scope.row.id)">取消</el-button>
                  </template>
              </el-table-column>
          </el-table>
      </el-dialog>

        <!-- 科目介绍 -->
        <el-dialog :title="course.name" :visible.sync="introductionVisible" width="80%" center>
            <div class="ql-editor" v-html="course.introduction"></div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="introductionVisible = false">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 考试操作说明 -->
        <el-dialog  title="CSA考试说明" :visible.sync="attentionVisible"  width="80%" center>
            <div class="dialog-content">
                <h4>注意事项</h4>
                <div class="ql-editor" v-html="course.attention">
                </div>
                <h4>操作说明</h4>
                <ul>
                    <li>
                        <el-button size="small" class="sample-bt"></el-button>表示该题未作答
                    </li>
                    <li>
                        <el-button size="small" type="warning" class="sample-bt"></el-button>表示该题被标记，答案尚未确定</li>
                    <li class="tips">
                        请注意：当你主动提交答卷或考试时间到，系统自动提交答卷时，保存或被标记的题目答案都会作为你的最终答案，提交到系统评分
                    </li>
                </ul>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="xx-large" type="success" @click="nextStep">下一步</el-button>
            </span>
        </el-dialog>

        <el-dialog center title="摄像头调试" :visible.sync="debugCameraVisible"  width="100%" @close="closeDebugCamera">
            <div class="debug-camera">
                <ul style="color: #606266">
                    <li >
                        1、请使用内置摄像头，或将外接摄像头放置于屏幕正上方，以便我们能够准确检测您的人脸。
                    </li>
                    <li >
                        2、请将您的脸部保持在画面中央并正视屏幕，这样我们可以更好地识别您的身份。
                    </li>
                    <li>
                        3、测试准备好后，请点击“完成测试”。
                    </li>
                    <li>
                        4、如果您在 Edge 浏览器第一次授权访问摄像头后未能正常显示画面，请尝试刷新页面后继续操作。
                    </li>
                </ul>
                <div id="debugUserVideo"></div>
                <div style="text-align: center">
                    <el-button type="primary" size="small" @click="skipDebugCamera" :disabled="!debugCameraOnPalying">完成测试</el-button>
<!--                    <el-button v-if="debugCameraFailCount>0" type="primary" size="small" @click="skipDebugCamera">跳过</el-button>-->
                </div>
            </div>
        </el-dialog>

        <!-- 温馨提示 -->
        <el-dialog title="温馨提示" :visible.sync="tipsVisible" width="80%" center>
            <p v-if="course.chance>0">你剩余{{course.chance}}次考试机会。是否确定进入考试页面，开始考试？</p>
            <!-- <p v-if="itemCourse.chance==0">你剩余{{itemCourse.chance}}次考试机会，请联系C-CSA工作人员：18024312752缴纳考试费用并获得考试权限。</p> -->
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="continueTest">是</el-button>
                <el-button type="primary" @click="tipsVisible = false">否</el-button>
            </span>
        </el-dialog>


        <!-- 付费 -->
        <el-dialog title="选择支付方式" :visible.sync="payInfoVisible" center>
            <div style="text-align:center;">
                <div v-if="enableAlipay" class="pay-way alipay" @click="payWay=1" :class="{ active: payWay===1}">
                    <div class="triangle">
                        <i class="el-icon-check"></i>
                    </div>
                </div>
                <div v-if="enableWxpay" class="pay-way wxpay" @click="payWay=2" :class="{ active: payWay===2}">
                    <div class="triangle">
                        <i class="el-icon-check"></i>
                    </div>
                </div>
                <div style="margin-top: 5px">温馨提示：购买考试机会后不予退款，建议您确认无误后购买</div>
            </div>
            <div class="pay-bottom">
                <div>应付金额：<span class="red" style="margin-right: 15px" >￥{{course.price}}</span></div>
                <el-button @click="createOrder()"  type="warning" class="to-pay">立即支付</el-button>
            </div>
        </el-dialog>
        
        <!-- 关闭所有支付渠道时购买提示 -->
        <el-dialog title="温馨提示" :visible.sync="payTipsVisible" width="80%" center>
            <p >你剩余{{course.chance}}次考试机会，请联系C-CSA工作人员：18024312752缴纳考试费用并获得考试权限。</p>
        </el-dialog>

<!--        <el-dialog title="当前操作需要支付宝扫码人脸识别认证" width="30%" :visible.sync="faceCertifyVisible" center @close="stopFaceCertifQuery">-->
<!--            <div style="text-align: center" @click="refreshCertifyUrl()">-->
<!--                <vue-qr  logoSrc="/alipay.png"  :text="faceCertifyUrl" :size="200" :margin="0" ></vue-qr>-->
<!--            </div>-->
<!--            <div style="text-align: center;color:red">-->
<!--                <p>若人脸识别认证失败，请检查个人信息页面的姓名/身份证号码是否准确</p>-->
<!--            </div>-->
<!--        </el-dialog>-->
    </div>
</template>
<script>
import Bus from '../bus.js';
import VueQr from 'vue-qr'
import { AliRTSPusher } from 'aliyun-rts-pusher';
import dateFormat from 'format-datetime';
export default {
    components:{VueQr},
    props: {
        course: {
            type: Object,
            required: true
        }
    },
    data:()=> {
        return {
            introductionVisible : false,
            tipsVisible: false,
            attentionVisible : false,
            payInfoVisible: false,
            payTipsVisible: false,
            appointmentVisible: false,
            enableWxpay: false,
            enableAlipay: false,
            payWay: 1,
            appointmentPlanList:[],
            faceCertifyVisible:false,
            faceCertifyUrl:null,
            debugCameraVisible:false,
            debugCameraFailCount:0,
            debugCameraOnPalying:false,
        }
    },
    computed: {
        isLogin: function() {
             return this.$store.state.userInfo&&this.$store.state.userInfo.chName ? true: false;
        }
    },
    async mounted() {
        let url = new URL(window.location.href);
        let subjectId = decodeURIComponent(url.searchParams.get('subjectId'))
        let response = decodeURIComponent(url.searchParams.get('response'))
        console.log("mounted",subjectId,response)
        if (this.course.id == subjectId && 'null' !== response) {
            let params = JSON.parse(response)
            if (params.code !== 1000) {
                await  this.$confirm(`人脸识别失败：${params.reason}`, '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    showClose: false,
                    type: 'warning'
                });
                window.location.href = `${window.location.protocol}//${window.location.host}/#/home`;
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: "正在确认人脸识别结果...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            let res = await this.$axios.get(`/user/faceCertifyResult2?certifyId=${params.extInfo.certifyId}`);
            loading.close();
            if (res.code === 200 && true === res.data) {
                localStorage.setItem("nextStep",subjectId)
                window.location.href = `${window.location.protocol}//${window.location.host}/#/home`;
                return;
            } else{
                this.$message.warning("确认人脸识别结果失败")
            }
        }
        if (this.course.id ==localStorage.getItem("nextStep")) {
            localStorage.removeItem("nextStep")
            this.initCamera()
        }
    },
    methods: {
        async haveTest() {
            /** 检查是否pc浏览器*/
            if (this.isMobile()) {
                this.$confirm("请在PC端进行考试", '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    showClose: false,
                    type: 'warning'
                });
                return;
            }
            const checkResult = await AliRTSPusher.checkSupport();
            if (!checkResult.isScreenCaptureSupported || !checkResult.isMediaDevicesSupported || !checkResult.isWebRTCSupported || !checkResult.isH264EncodeSupported) {
                this.$confirm("当前设备不满足考试要求，请更换Chrome或者Edge浏览器", '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    showClose: false,
                    type: 'warning'
                });
                return;
            }
            let cl = await AliRTSPusher.createClient().getDeviceManager().getCameraList();
            cl = cl.filter(mediaDeviceInfo => mediaDeviceInfo.label.indexOf('OBS')<0 && mediaDeviceInfo.label.indexOf('Virtual') <0)
            if (cl.length === 0) {
                this.$confirm("未发现可用的摄像头设备，请检查电脑是否已连接摄像头或摄像头驱动是否已安装。", '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    showClose: false,
                    type: 'warning'
                });
                return;
            }

            let res = await this.$axios.get("/record/existsOnTheExamRecord");
            if (res.data) {
                this.$message({
                    message: "你还有别的考试在进行中，请继续该科目考试！",
                    type: "warning"
                });
                return;
            }
            /** 检查是否已经完成实名认证 */
            if (1 !== this.$store.state.userInfo.faceCertify && -1 !== this.$store.state.userInfo.faceCertify) {
                this.$confirm("当前账号尚未实名认证，请前往个人中心进行认证！", '提示', {
                    confirmButtonText: '前往',
                    cancelButtonText: '取消',
                    showClose: false,
                    type: 'warning'
                }).then(() => {
                    this.$router.push("/user");
                }).catch(() => {
                    // do nothing
                });
                return;
            }

            if (this.course.appointmentType==='appointment') {
                let appointPlanRes = await this.$axios.get(`/appointment/appointment/success?subjectId=${this.course.id}`);
                if (null == appointPlanRes.data) {
                    this.$message({message: "未预约或预约已过期！", type: "warning"});
                    return;
                } else if (new Date(appointPlanRes.data.startTime).getTime() > Date.now()) {
                    this.$message({message: "未到约定时间："+appointPlanRes.data.startTime, type: "warning"});
                    return;
                }
            }
            this.attentionVisible = true;
        },
        async checkBeforeAppointment() {
          let res = await this.$axios.get(`/appointment/check/${this.course.id}`);
          if (res.code ===200 && !res.data) {
            this.$confirm( `预约须先通过科目：${res.errMsg}`,'',{
              showCancelButton:false,
              type: "error"
            });
            return;
          }
          await this.searchAppointPlan();
        },
        async searchAppointPlan() {
            let res = await this.$axios.post('appointment/planList',{
                subjectId:this.course.id,
                planDateStart: dateFormat(new Date(),'yyyy-MM-dd'),
                // planDateEnd:this.appointmentPlanDateRange[1]
            });
            if (res.code !==200) {
                this.appointmentVisible=false;
            } else {
                this.appointmentPlanList = res.data;
                this.appointmentVisible=true;
            }
        },
        async makeAppointment(planId) {
            let res = await this.$axios.get(`/appointment/make/${planId}`);
            await this.searchAppointPlan();
            this.$emit('update', null);
        },
        async cancelAppointment(planId) {
            let confirm = await this.$confirm('取消后不可再预约该次考试，是否确定取消？','确认取消', {type: 'warning'}).catch(err=>{return Promise.resolve(false)});
            if (!confirm) {
                return;
            }
            await this.$axios.get(`/appointment/cancel/${planId}`);
            await this.searchAppointPlan();
            this.$emit('update', null);
        },

        async refreshCertifyUrl() {
            window.clearInterval(this.faceCertifyResultSync);
            await this.$axios.get("/user/clearFaceCertifyCache");
            await this.faceCertify();
        },
        isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },

        // async nextStep() {
        //     /** 最后一次认证成功时间是否1小时内*/
        //     this.attentionVisible = false;
        //     let lastRes = await this.$axios.get("/user/lastFaceCertifySuccess");
        //     if (lastRes.code !== 200) {
        //         return;
        //     }
        //     if (null === lastRes.data) {
        //         await this.faceCertify();
        //         this.faceCertifyVisible = true;
        //     } else {
        //         this.initCamera();
        //     }
        // },

        async nextStep() {
            /** 最后一次认证成功时间是否1小时内*/
            this.attentionVisible = false;
            let lastRes = await this.$axios.get("/user/lastFaceCertifySuccess");
            if (lastRes.code !== 200) {
                return;
            }
            if ( null !== lastRes.data) {
                await this.initCamera();
                return;
            }
            let res = await this.$axios.post(`/user/faceCertify2`,
                {
                    subjectId: this.course.id,
                    type:1,
                    route: "/home",
                    metaInfo: window.getMetaInfo()
                })
            if (200 === res.code && null != res.data && null !== res.data.certifyUrl) {
                window.location.href = res.data.certifyUrl;
            } else {
                this.$message.error("获取人脸认证链接失败")
            }
        },
        // async faceCertify() {
        //     // 需要重新认证
        //     const loading = this.$loading({
        //         lock: true,
        //         text: "加载中",
        //         spinner: "el-icon-loading",
        //         background: "rgba(0, 0, 0, 0.7)"
        //     });
        //     let faceCertifyRes = await  this.$axios.get("/user/reFaceCertify");
        //     loading.close();
        //
        //     if (faceCertifyRes.code !== 200) {
        //         this.$message.error(faceCertifyRes.errMsg);
        //         return;
        //     }
        //
        //     this.faceCertifyUrl = faceCertifyRes.data.url;
        //     // reset 定时器
        //     if (null != this.faceCertifyResultSync) {
        //         window.clearInterval(this.faceCertifyResultSync)
        //     }
        //     this.faceCertifyResultSync = setInterval(  () => {
        //         this.faceCertifyQuery(faceCertifyRes.data.certifyId)
        //     }, 1000);
        // },
        // async faceCertifyQuery(certifyId) {
        //     if (localStorage.getItem("re_"+certifyId)) {
        //         return
        //     }
        //     let res = await this.$axios.get(`/user/faceCertifyResult?certifyId=${certifyId}`);
        //     if (res.code === 200 && res.data) {
        //         window.clearInterval(this.faceCertifyResultSync);
        //         localStorage.setItem("re_"+certifyId,certifyId)
        //         this.faceCertifyVisible = false;
        //         this.initCamera();
        //     } else if (res.code !== 200) {
        //         window.clearInterval(this.faceCertifyResultSync);
        //     }
        // },
        // stopFaceCertifQuery() {
        //     window.clearInterval(this.faceCertifyResultSync);
        //     this.faceCertifyResultSync = null;
        // },
        async checkFaceCertify(certifyId) {
            const loading = this.$loading({
                    lock: true,
                    text: "获取人脸识别结果...",
                    spinner: "el-icon-loading",
                    background: "rgba(0, 0, 0, 0.7)"
                });
            // let res = await this.$axios.get(`/user/faceCertifyResult2?certifyId=${certifyId}`);
            loading.close();

            if (res.code === 200 && true === res.data) {
                this.initCamera()
            } else if (res.code === 200 && false === res.data){
                this.$message.error("人脸识别未通过")
            } else {
                this.$message.error("人脸识别未结果错误")
            }
        },
        async initCamera() {
            //这里先判断是否需要开启摄像头,如果不需要，直接往下走
            let enableCameraRes = await this.$axios.get(
                "/systemConfig/getEnableCamera"
            );
            // 如果不需要监控，下一步
            if (!enableCameraRes.data) {
                this.confirmIntoTest();
            } else {
                this.debugCameraOnPalying = false
                this.debugCameraVisible=true;
                this.$nextTick(async ()=>{
                    this.pushClient = AliRTSPusher.createClient();
                    const userVideo = this.pushClient.setRenderView('debugUserVideo'); // 静音自动播放
                    userVideo.controls=false;
                    userVideo.muted =true;
                    this.pushClient.setVideoQuality("1080p_1");
                    let cl = await AliRTSPusher.createClient().getDeviceManager().getCameraList();
                    cl = cl.filter(mediaDeviceInfo => mediaDeviceInfo.label.indexOf('OBS')<0 && mediaDeviceInfo.label.indexOf('Virtual') <0)
                    if (cl[0].deviceId ==='') {
                        this.cameraStreamId = await this.pushClient.startCamera().catch(error=> {
                            this.debugCameraVisible=false;
                            this.closeDebugCamera();
                            let message = error.errorCode === 10004 && error.message=== 'video device not allowed'?
                            "已禁止使用摄像头，请重置网站设置后刷新页面再继续":`遇到错误${error.errorCode}:${error.message}`
                            this.$confirm(message, '错误', {
                                confirmButtonText: '确定',
                                showCancelButton: false,
                                showClose: false,
                                type: 'error'
                            });
                        })
                        userVideo.onplaying=()=> {this.debugCameraOnPalying = true}
                    } else {
                        this.cameraStreamId = await this.pushClient.startCamera(cl[0].deviceId).catch(error => {
                            this.debugCameraVisible=false;
                            this.closeDebugCamera();
                            let message = error.errorCode === 10004 && error.message=== 'video device not allowed'?
                                "已禁止使用摄像头，请重置网站设置后刷新页面再继续":`遇到错误${error.errorCode}:${error.message}`
                            this.$confirm(message, '错误', {
                                confirmButtonText: '确定',
                                showCancelButton: false,
                                showClose: false,
                                type: 'error'
                            });
                        })
                        userVideo.onplaying=()=> {this.debugCameraOnPalying = true}
                    }
                })
            }
        },
        closeDebugCamera() {
            if (this.pushClient) {
                this.pushClient.stopCamera();
                this.pushClient.dispose();
                this.cameraStreamId = null;
                this.pushClient = null;
            }
        },
        async debugCamera() {
            const loading = this.$loading({
                lock: true,
                text: "检测中...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            const track = this.pushClient.getSourceStream(this.cameraStreamId).getVideoTracks()[0];
            this.imageCapture = new ImageCapture(track);
            let blob = await  this.imageCapture.takePhoto();
            const formData = new FormData;
            formData.set("file",blob,"capture.jpg");
            let checkImage= await this.$axios.post("/user/checkImageCapture",formData);
            if (checkImage.code != 200) {
                loading.close()
                return;
            }
            if (checkImage.data && checkImage.data.passed==="T") {
                loading.close()
                this.debugCameraFailCount=0;
                this.debugCameraVisible=false;
                this.pushClient.dispose()
                this.confirmIntoTest();
            } else if (checkImage.data){
                this.debugCameraFailCount = this.debugCameraFailCount+1;
                if (checkImage.data.mismatchReason && checkImage.data.mismatchReason === 'HIGH_RISK') {
                    this.$message({
                        message:`检测失败次数过多,请稍后重试`,
                        type:"warning",
                    });
                } else {
                    this.$message({
                        message:`检测未通过${checkImage.data.mismatchReason},请确保人像在画面中央并正视屏幕（摄像头）后重试`,
                        type:"warning",
                    });
                }
                loading.close();
            }
        },
        skipDebugCamera() {
            this.closeDebugCamera()
            this.debugCameraVisible=false;
            this.confirmIntoTest();
        },
        confirmIntoTest() {
            this.tipsVisible=true;
        },
        /** 继续考试 */
        async continueTest() {
            /** 检查是否pc浏览器*/
            if (this.isMobile()) {
                this.$confirm("请在PC端进行考试", '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    showClose: false,
                    type: 'warning'
                });
                return;
            }
            const checkResult = await AliRTSPusher.checkSupport();
            if (!checkResult.isScreenCaptureSupported || !checkResult.isMediaDevicesSupported || !checkResult.isWebRTCSupported || !checkResult.isH264EncodeSupported) {
                this.$confirm("当前设备不满足考试要求，请更换", '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    showClose: false,
                    type: 'warning'
                });
                return;
            }
            let cl = await AliRTSPusher.createClient().getDeviceManager().getCameraList();
            cl = cl.filter(mediaDeviceInfo => mediaDeviceInfo.label.indexOf('OBS')<0 && mediaDeviceInfo.label.indexOf('Virtual') <0)
            if (cl.length === 0) {
                this.$confirm("当前设备不满足考试要求，请更换有摄像头设备", '提示', {
                    confirmButtonText: '确定',
                    showCancelButton: false,
                    showClose: false,
                    type: 'warning'
                });
                return;
            }


            console.log()
            this.$router.push({
                path: "/exam",
                query: { id: this.course.id }
            });
        },
        async toPay() {
            if(this.isLogin){
                let res = await this.$axios.get('/systemConfig/getSystemConfig');
                if (res.code != 200) {
                    return;
                }
                let systemConfig = res.data;
                this.enableWxpay = systemConfig.enableWxpay;
                this.enableAlipay = systemConfig.enableAlipay;
                if (!systemConfig.enableWxpay && !systemConfig.enableAlipay) {
                    this.payTipsVisible = true;
                } else {
                    this.payInfoVisible = true;
                }

            }else{
                Bus.$emit('toOpenLigon',true);
            }
        },
        async createOrder() {
            if(!this.payWay){
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: "正在创建订单，请稍后...",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            let res =  await this.$axios.post('/order/createOrder', {type:1,payChannel:this.payWay, subjectId:this.course.id});
            loading.close();
            //当前科目存在待支付订单
            if (res.code == 601) {
                this.$confirm('当前科目存在待支付订单,立即前往订单记录处理？','提示', {
                    confirmButtonText: '前往',
                    cancelButtonText: '取消',
                    showClose: false,
                    type: 'warning'
                }).then(() => {
                    this.$router.push("order");
                }).catch(()=>{});
                return;
            }

            if (res.code == 200) {
                this.$router.push("order");
            }
        },
        timeFormat(row, column, dateTime, index) {
            if (dateTime) {
                return dateTime.substring(11);
            } else {
                return dateTime;
            }
        }
    }
};
</script>
<style scoped>
.el-icon-check{
    position: relative;
    left: -12px;
    top: 3px;
    color: #fff;
}
.triangle{
    opacity: 0;
    width: 0;
    height: 0;
    border-bottom: 20px solid red;
    border-left: 20px solid transparent;
    position: absolute;
    bottom: 0;
    right: 0;
}
.to-pay{
    background: #f01414;
    border-radius: 0;
    width: 140px;
    height: 40px;
}
.pay-bottom{
    text-align: right;
    color: #07111b;
    line-height: 40px;
    padding-top: 10px;
}
.red{
    color:#f01414;
    font-size: 24px;
}
.pay-way{
    position: relative;
    border-radius: 6px;
    overflow: hidden;
    width: 192px;
    height: 86px;
    background-color: #f3f5f7;
    border: 2px solid #f3f5f7;
    cursor: pointer;
    background-image: url(../assets/pay_s.png);
    display: inline-block;
}

.pay-way.alipay{
    background-position: 33px -304px;
    background-repeat: no-repeat;
    margin-right: 46px;
}

.pay-way.wxpay{
    background-position: 30px -423px;
    background-repeat: no-repeat;
}
.pay-way.active{
    border-color: #f01414;
}
.pay-way.active .triangle{
    opacity: 1;
}
.exam-course {
  margin: 20px 10px;
}

.imgbox img {
  width: 100%;
  cursor: pointer;
}

.time {
  font-size: 13px;
  color: #999;
}

.tips {
  text-indent: 2em;
}
a {
  text-decoration: none;
  color: #09c;
}
p {
  text-indent: 2em;
}
.to-test {
  font-size: 16px;
  padding: 0;
  float: right;
}

.dialog-content {
  border-bottom: 1px solid #bababa;
  padding-bottom: 20px;
}
.sample-bt {
  padding: 0;
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-right: 10px;
}
h4 {
  font-size: 16px;
  line-height: 40px;
  color: #07091d;
}
ol {
  margin-bottom: 20px;
}
li {
  line-height: 28px;
}
@media screen and (max-width: 767px) {
  .dialog-content {
    padding-bottom: 10px;
  }
  .to-test,
  .el-card {
    font-size: 14px;
  }
  h4 {
    font-size: 14px;
  }
  li {
    font-size: 12px;
  }
}
</style>

